import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Shell, Card } from "../components/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { apiError, http } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("La contraseña debe tener al menos 8 caracteres.");
    if (password !== repeat) return setError("Las dos contraseñas no coinciden.");
    setBusy(true);
    try {
      await http.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Shell title="Nueva contraseña"
      subtitle="Elija una contraseña nueva para su cuenta de SISU."
      testid="reset-password-page">
      <Card className="max-w-xl">
        {!token && (
          <p data-testid="reset-no-token" className="text-lg text-red-700">
            El enlace no es válido. Solicite de nuevo el restablecimiento desde la pantalla de acceso.
          </p>
        )}
        {token && done && (
          <div data-testid="reset-done">
            <p className="text-lg">Su contraseña se ha actualizado correctamente.</p>
            <Button data-testid="reset-go-login-btn" className="mt-6 h-14 text-lg"
              onClick={() => navigate("/entrar")}>
              Ir al acceso
            </Button>
          </div>
        )}
        {token && !done && (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <Label htmlFor="np" className="text-lg">Nueva contraseña</Label>
              <PasswordInput id="np" testid="reset-password-input" required
                autoComplete="new-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-2 h-14 text-lg" />
            </div>
            <div>
              <Label htmlFor="np2" className="text-lg">Repita la nueva contraseña</Label>
              <PasswordInput id="np2" testid="reset-password-repeat-input" required
                autoComplete="new-password" value={repeat}
                onChange={(e) => setRepeat(e.target.value)} className="mt-2 h-14 text-lg" />
            </div>
            {error && (
              <p data-testid="reset-error" className="rounded-lg bg-red-50 p-4 text-base text-red-700">{error}</p>
            )}
            <Button data-testid="reset-submit-btn" disabled={busy} className="h-14 w-full text-lg">
              {busy ? "Guardando..." : "Guardar la nueva contraseña"}
            </Button>
          </form>
        )}
      </Card>
    </Shell>
  );
}
